import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import i18n from '@i18n';

import BetbookCommentEditor from '@/betbook/components/betbook-comment-editor/BetbookCommentEditor';
import BetbookPostComments from '@/betbook/views/BetbookPostComments';
import Accordion from '@/common/components/Accordion';
import { topic$ } from '@/betbook/subs';
import { clearComments, initPostComments, loadRedactorStatus } from '@/betbook/handlers';

function EditorWithComments({ className = '', commentsCount, subjectType, subjectId }) {
    const { subscribe } = useReframe();
    useEffect(() => dispatch(loadRedactorStatus), []);
    useEffect(() => {
        dispatch(initPostComments(subjectType, subjectId));
        return () => dispatch(clearComments);
    }, [subjectType, subjectId]);

    const topic = subscribe(topic$);
    const topicStatus = topic?.status;
    if (topicStatus === 'HIDDEN') {
        return null;
    }

    const title = (
        <span>
            <b>{`${i18n('betbook.comments.title')} `}</b>({commentsCount})
        </span>
    );

    return (
        <Accordion className={className} title={title} expanded>
            {topicStatus === 'ENABLED' && <BetbookCommentEditor subjectId={subjectId} subjectType={subjectType} />}
            <BetbookPostComments subjectId={subjectId} subjectType={subjectType} topicStatus={topicStatus} />
        </Accordion>
    );
}

export default EditorWithComments;
